<details-section title="Methodology" [showDetails]="false">
  <div class="container" [formGroup]="form">
    <div [formGroup]="methodologyPromptGroup">
      <qai-field [label]="methodologyPromptLabel">
        <textarea
          qai-textarea
          autosize
          [maxLines]="30"
          qaiTrimLeading
          qaiPasteClean
          formControlName="promptText"
        ></textarea>
      </qai-field>
    </div>
  </div>
</details-section>
